/* Trybe video cards: tap the frame or play button -> inline <video playsinline controls preload="none"> with the
   Shopify-hosted mp4; pauses any other card's video; restores the poster on end. Nothing loads before the tap. */
(() => {
  let current = null;
  function stop(frame) {
    const vid = frame.querySelector('video');
    if (vid) { try { vid.pause(); } catch (e) {} vid.remove(); }
    frame.classList.remove('is-playing');
    if (current === frame) current = null;
  }
  function play(frame) {
    const src = frame.dataset.src;
    if (!src) return;
    if (current && current !== frame) stop(current);
    let vid = frame.querySelector('video');
    if (!vid) {
      vid = document.createElement('video');
      vid.setAttribute('playsinline', '');
      vid.setAttribute('controls', '');
      vid.preload = 'none';
      vid.poster = frame.dataset.poster || '';
      vid.src = src;
      vid.addEventListener('ended', () => stop(frame));
      vid.addEventListener('pause', () => { if (vid.ended) stop(frame); });
      frame.appendChild(vid);
    }
    frame.classList.add('is-playing');
    current = frame;
    const p = vid.play();
    if (p && p.catch) p.catch(() => {});
    vid.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const frame = e.target.closest('[data-sm-video]');
    if (!frame || e.target.closest('video')) return;
    play(frame);
  });
  // pause playing videos when their card scrolls away
  document.addEventListener('sm:carousel:change', () => { if (current) stop(current); });
})();
